export default __webpack_public_path__ + "static/media/share-icon.4abc5111.svg";